import { render, staticRenderFns } from "./CS-results.vue?vue&type=template&id=acfe6ec0"
import script from "./CS-results.vue?vue&type=script&lang=js"
export * from "./CS-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports